module.exports = __webpack_public_path__ + "assets/logo-white.d6ccf36a.svg";